export default {
  name: 'reset-password',
  path: '/reset-password',
  i18n: ['auth/reset-password', 'app'],
  loadComponent: () => import('./index')
};
